import { Component, OnInit } from '@angular/core';
import { GavePermissionService } from 'src/app/core/services/gave-permission.service';

@Component({
  selector: 'app-gave-permission',
  templateUrl: './gave-permission.component.html',
  styleUrls: ['./gave-permission.component.scss']
})
export class GavePermissionComponent implements OnInit {

  userGavePermission: boolean = true;
  urlPermission: string = "";

  constructor(private gavePermissionService: GavePermissionService) {
  }

  ngOnInit(): void {
    this.gavePermissionService.verifyUserGavePermission().then((resp: any) => {
      this.userGavePermission = resp;
      if(!this.userGavePermission){
        this.gavePermissionService.getUrlPermission().then((resp: string) => {
          this.urlPermission = resp;
        });
      }
    });
  }
}
